import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { navLinks } from "../mock";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-white/95 backdrop-blur-md shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-[#0e0e0f] flex items-center justify-center text-white font-semibold tracking-wider text-[13px]">
            STG
          </div>
          <div className="flex flex-col leading-none">
            <span className={`font-serif-display text-xl ${scrolled ? "text-[#0e0e0f]" : "text-[#0e0e0f]"}`}>STG</span>
            <span className="text-[10px] tracking-[0.24em] text-neutral-500 mt-0.5">ECHIPĂ PUTERNICĂ</span>
          </div>
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="link-underline text-[15px] text-neutral-800 hover:text-[#0e0e0f]"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="#contact"
          className="hidden md:inline-flex items-center bg-[#0e0e0f] text-white px-5 py-3 rounded-full text-sm font-medium hover:bg-[#1e1e22] transition-colors duration-200"
        >
          Începe un Proiect
        </a>

        <button
          className="md:hidden p-2 text-[#0e0e0f]"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-white border-t border-neutral-100">
          <div className="px-6 py-6 flex flex-col gap-5">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                className="text-neutral-800 text-base"
                onClick={() => setOpen(false)}
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              className="mt-2 bg-[#0e0e0f] text-white px-5 py-3 rounded-full text-sm font-medium text-center"
            >
              Începe un Proiect
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
